import { makeStyles, createStyles } from "@material-ui/core/styles";

export const useAutoSizedTableStyles = makeStyles({
  table: {
    "& .ReactVirtualized__Table__Grid": {
      height: "calc(99vh - 192px) !important",
    },
  },
});

export const tableStyles = (theme) =>
  createStyles({
    flexContainer: {
      display: "flex",
      alignItems: "center",
      boxSizing: "border-box",
    },
    table: {
      overflowX: "auto",

      // temporary right-to-left patch, waiting for
      // https://github.com/bvaughn/react-virtualized/issues/454
      "& .ReactVirtualized__Table__headerRow": {
        flip: false,
        paddingRight: theme.direction === "rtl" ? "0 !important" : undefined,

        "& .ReactVirtualized__Table__headerColumn": {
          display: "flex",
        },
      },

      "& .ReactVirtualized__Table__Grid": {
        paddingBottom: theme.spacing(3),
      },
    },
    autoSizedTable: {
      width: "calc(100vw - 40px)",

      "& .ReactVirtualized__Table__Grid": {
        height: "calc(99vh - 192px) !important",
      },
    },
    multiTable: {
      "& .ReactVirtualized__Table__headerRow .ReactVirtualized__Table__headerColumn":
        {
          overflow: "hidden",

          "&:last-child": {
            paddingLeft: 9,
          },
        },
    },
    tableRow: {
      cursor: "initial",
    },
    tableRowHover: {
      "&:hover": {
        backgroundColor: theme.palette.grey[200],
      },
    },
    tableColumnRight: {
      paddingLeft: 9,
    },
    tableCellMain: {
      padding: theme.spacing(0, 2, 0, 0),
      borderBottom: "none",
    },
    tableHeadCellMain: {
      padding: theme.spacing(0, 2, 0, 0),
      overflow: "hidden",
    },
  });
